import { Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'

interface RecentProjectsLinkProps {}

const RecentProjectsLinkComponent: React.FC<RecentProjectsLinkProps> = ({}) => {
  const navigate = useNavigate()

  const onViewAllRecentProjectClick = () => {
    navigate('/projects')
  }

  return (
    <Button
      disableRipple
      variant='text'
      onClick={onViewAllRecentProjectClick}
      sx={{
        color: '#06004A',
        fontSize: '0.76rem',
        fontWeight: 500,
        lineHeight: 'normal',
        textTransform: 'capitalize',
        p: 0,
      }}
    >
      View All Recent Projects
    </Button>
  )
}

export default RecentProjectsLinkComponent
